export default __webpack_public_path__ + "static/media/pen-active-lime.ddeaa677.svg";